import { IWorkflowRun } from 'interface/workflowInterface';
import { HeadCell } from 'components/common/TableCommon';
import { ReactComponent as CancelIcon } from 'assets/icons/cancel.svg';
import { ReactComponent as PauseIcon } from 'assets/icons/pause.svg';
import { ReactComponent as ResumeIcon } from 'assets/icons/resume.svg';
import { ReactComponent as ArchiveIcon } from 'assets/icons/archive.svg';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import './style.scss';

export const createHeadCellList = (
  onResumeWorkflow: (_workflowId: string) => void,
  onPauseWorkflow: (_workflowId: string) => void,
  onCancelWorkflow: (_workflowId: string) => void,
  onArchiveWorkflow: (_workflowId: string) => void,
  handleMenuOpen: (
    _event: React.MouseEvent<HTMLElement>,
    _workflowId: string,
  ) => void,
  handleMenuClose: () => void,
  anchorEl: HTMLElement | null,
  selectedWorkflowId: string | null,
): HeadCell<IWorkflowRun>[] => [
  {
    id: 'name',
    label: 'Name',
    hide: false,
    cellRender: row => {
      return <>{row?.Name}</>;
    },
  },
  {
    id: 'startedAt',
    label: 'Started At',
    hide: false,
    cellRender: row => {
      return (
        <>{row?.StartedAt ? new Date(row.StartedAt).toLocaleString() : ''}</>
      );
    },
  },
  {
    id: 'completedAt',
    label: 'Completed At',
    hide: false,
    cellRender: row => {
      return (
        <>
          {row?.CompletedAt ? new Date(row.CompletedAt).toLocaleString() : ''}
        </>
      );
    },
  },
  {
    id: 'status',
    label: 'Status',
    hide: false,
    cellRender: row => {
      return <>{row?.Status}</>;
    },
  },
  {
    id: 'actions',
    label: 'Actions',
    hide: false,
    cellRender: (row: IWorkflowRun) => {
      const open = Boolean(anchorEl) && selectedWorkflowId === row.ID;

      const handleAction = (action: () => void) => {
        action();
        handleMenuClose();
      };

      return (
        <div className="action-buttons-cell" onClick={e => e.stopPropagation()}>
          <IconButton onClick={e => handleMenuOpen(e, row.ID)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            onClick={e => e.stopPropagation()}>
            <MenuItem
              onClick={() => handleAction(() => onResumeWorkflow(row.ID))}>
              <ResumeIcon className="menu-icon" />
              Resume
            </MenuItem>
            <MenuItem
              onClick={() => handleAction(() => onPauseWorkflow(row.ID))}>
              <PauseIcon className="menu-icon" />
              Pause
            </MenuItem>
            <MenuItem
              onClick={() => handleAction(() => onCancelWorkflow(row.ID))}>
              <CancelIcon className="menu-icon" />
              Cancel
            </MenuItem>
            <MenuItem
              onClick={() => handleAction(() => onArchiveWorkflow(row.ID))}>
              <ArchiveIcon className="menu-icon" />
              Archive
            </MenuItem>
          </Menu>
        </div>
      );
    },
  },
];
